/**
* Created by vouill on 5/7/18.
*/

<template>
  <div id="login">
    <div class="login-card">

      <div
        v-if="isSignUp"
        class="card-title">
        <h1>🦊 Bienvenue !</h1>
      </div>

      <div
        v-if="isSignIn"
        class="card-title">
        <h1>🦊 Heureux de vous revoir !</h1>
      </div>

      <div
        v-if="isResetPassword"
        class="card-title">
        <h1>Réinitialiser mon mot de passe</h1>
      </div>

      <div class="content">
        <p
          v-if="isSignUp"
        >
          Creez votre mot de passe.
        </p>
        <form
          @submit.prevent="onSubmit">
          <input
            v-if="isSignIn || isResetPassword"
            id="email"
            type="email"
            name="email"
            title="email"
            placeholder="Email"
            required
            autofocus
            v-model="email">
          <input
            v-if="!isResetPassword"
            id="password"
            type="password"
            name="password"
            title="password"
            placeholder="Password"
            v-model="password"
            required>
          <div
            v-if="isSignIn"
            class="level options">
            <router-link
              class="btn btn-link "
              to="reset-password">
              Mot de passe oublié?</router-link>
            <a
              class="btn btn-link"
              @click="showModal=true"
            >Inscription</a>
          </div>

          <button
            v-if="isSignUp"
            type="submit"
            :class="['button', 'is-primary', 'is-rounded', {'is-loading': status === 'loading' }]">
            S'inscrire
          </button>

          <button
            v-if="isResetPassword"
            type="submit"
            :class="['button', 'is-primary', 'is-rounded', {'is-loading': status === 'loading' }]">
            Réinitialiser
          </button>

          <button
            v-if="isSignIn"
            type="submit"
            :class="['button', 'is-primary', 'is-rounded', {'is-loading': status === 'loading' }]">
            S'identifier
          </button>

        </form>
        <article
          v-if="isResetPassword && status === 'error'"
          class="message is-danger">
          <div class="message-body">
            Cet email n'est pas enregistré
          </div>
        </article>
        <article
          v-if="isSignIn && status === 'error'"
          class="message is-danger">
          <div class="message-body">
            Email/password incorrect
          </div>
        </article>
      </div>
      <div :class="['modal', {'is-active': showModal}]">
        <div
          class="modal-background"
          @click="showModal=false"
        />
        <div class="modal-card">
          <section class="modal-card-body">
            <div class="content">
              <h1>Comment m'inscire ?</h1>
              <p>Rien de plus simple, devenez adherent et vous recevrez un email pour creer un compte.</p>
              <p>Vous pouvez soit vous adherer <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.helloasso.com/associations/metis/adhesions/adhesion-annuelle-metis">ici</a> ou nous envoyer un <a href="mailto:contact@metis-lab.com">mail</a> pour adherer d une autre façon</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$primary: #ff9942;
$grey-darker: hsl(0, 0%, 21%);
$grey-dark: hsl(0, 0%, 29%);
$grey: hsl(0, 0%, 48%);
$grey-light: hsl(0, 0%, 71%);
$grey-lighter: hsl(0, 0%, 86%);

.message {
  margin-top: 2em;
}
#login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f7f7f7;

  .login-card {
    background: #fff;
    width: 24rem;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);

    .card-title {
      background-color: darken($primary, 5%);
      padding: 2rem;

      h1 {
        color: #fff;
        text-align: center;
        font-size: 1.2rem;
      }
    }

    .content {
      padding: 3rem 2.5rem 5rem;
    }

    input {
      display: block;
      width: 100%;
      font-size: 1rem;
      margin-bottom: 1.75rem;
      padding: 0.25rem 0;
      border: none;
      border-bottom: 1px solid $grey-lighter;
      transition: all 0.5s;

      &:hover {
        border-color: $grey;
      }

      &:active,
      &:focus {
        border-color: $primary;
      }
    }

    .checkbox {
      color: $grey-light;
      font-size: 0.8rem;

      span {
        margin-left: 0.5rem;
      }
    }

    button {
      width: 100%;
      height: 50px;
    }

    a {
      font-size: 0.8rem;
    }

    .options {
      color: $grey-light;
      margin-bottom: 1.5rem;
    }
  }
}

label {
  cursor: pointer;
}

.regular-checkbox {
  display: none;
}

.regular-checkbox + label {
  background-color: #fafafa;
  border: 1px solid $grey-lighter;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 7px;
  border-radius: 3px;
  display: inline-block;
  position: relative;
}

.regular-checkbox:checked + label {
  background-color: #e9ecee;
}

.regular-checkbox:checked + label:after {
  content: "\2714";
  font-size: 11px;
  position: absolute;
  top: 0;
  left: 3px;
  color: $grey-light;
}

input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}
</style>

<script>
export default {
  name: "Signup",
  data() {
    return {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      company: "",
      showModal: false
    };
  },
  props: {
    submit: {
      type: Function
    },
    status: String,
    isSignIn: Boolean,
    isResetPassword: Boolean,
    isSignUp: Boolean
  },
  methods: {
    onSubmit: function() {
      const { email, password, firstName, lastName, company } = this;
      this.$emit("submit", {
        email,
        password,
        firstName,
        lastName,
        company
      });
    }
  }
};
</script>
